import Step from '../../constants/Step'
import { Order } from '../order/Order'

export const OrderProductStatus = {
  OPEN             :'O',
  ACCEPTED         :'A',
  READY_FOR_PICKUP :'R',
  PICKED_UP        :'P',
  DELIVERED        :'D',
  RETURN_REQUEST   :'B',
  RETURN_APPROVED  :'C',
  RETURN_DECLINED  :'E',
  RETURNED         :'F',
  CANCELED         :'I',
  DECLINED         :'K',
}

export interface IOrderProduct {
  id: number
  name: string
  code: string
  status: string
  statusCode: string
  itemId: number
  price: number
  subtotal: number
  isLabeled: boolean
  isCanceled: boolean
  isDeclined: boolean
  label: string|null
  acceptQuantity: number
  quantity: number
  options: Record<string, string>
  imageUrl: string|null
  shortDescription: string
  logisticClass: string|null
}

export interface IOrderProductFactory extends IOrderProduct {
}

export class OrderProduct {
  id: number
  name: string
  code: string
  status: string
  statusCode: string
  itemId: number
  price: number
  subtotal: number
  isLabeled: boolean
  isCanceled: boolean
  isDeclined: boolean
  label: string|null
  acceptQuantity: number
  quantity: number
  options: Record<string, string>
  imageUrl: string|null
  shortDescription: string
  logisticClass: string|null
  _order: Order|null = null

  _hasNextConsolidatedProduct: boolean|null = null

  constructor(orderProductData: IOrderProduct) {
    this.id = orderProductData.id
    this.name = orderProductData.name
    this.code = orderProductData.code
    this.status = orderProductData.status
    this.statusCode = orderProductData.statusCode
    this.itemId = orderProductData.itemId
    this.price = orderProductData.price
    this.subtotal = orderProductData.subtotal
    this.isLabeled = orderProductData.isLabeled
    this.isCanceled = orderProductData.isCanceled
    this.isDeclined = orderProductData.isDeclined
    this.label = orderProductData.label
    this.acceptQuantity = orderProductData.acceptQuantity
    this.quantity = orderProductData.quantity
    this.options = orderProductData.options
    this.imageUrl = orderProductData.imageUrl
    this.shortDescription = orderProductData.shortDescription
    this.logisticClass = orderProductData.logisticClass
  }

  setOrder(order: Order): void {
    this._order = order
  }

  get order(): Order {
    if (!this._order) {
      throw new Error('Orphan product was found: no order is set')
    }
    return this._order
  }
  canMoveToInProgress(): boolean {
    return this.order?.cycle?.column?.step === Step.INCOMING && !this.isCanceled
  }

  isInProgress(): boolean {
    return this.order.cycle?.column?.step === Step.IN_PROGRESS
  }

  canConsolidate(): boolean {
    return this.canPrint()
  }

  canDecline(): boolean {
    return !this.isDeclined
      && [Step.INCOMING, Step.IN_PROGRESS].includes(this.order?.cycle?.column?.step!)
  }

  canPrint(): boolean {
    return !this.isLabeled &&
      !this.isCanceled &&
      this.order.cycle?.column?.step === Step.IN_PROGRESS
  }

  canUnPrint(): boolean {
    return this.isLabeled &&
      this.order.cycle?.column?.step === Step.IN_PROGRESS
  }

  get hasNextConsolidatedProduct(): boolean {
    if (this._hasNextConsolidatedProduct === null) {
      if(!this.order) {
        throw new Error('No order in product')
      }

      const currentProductIndex = this.order.products.indexOf(this)

      const nextProductIndex = currentProductIndex > -1 ? currentProductIndex + 1 : -1
      const nextProduct: OrderProduct | undefined = this.order.products[nextProductIndex]
      this._hasNextConsolidatedProduct = nextProduct ? nextProduct.label === this.label : false

    }

    return this._hasNextConsolidatedProduct
  }
}

export const createOrderProduct = (orderProductData: IOrderProduct): OrderProduct => {
  return new OrderProduct(orderProductData)
}
